module.exports = __webpack_public_path__ + "img/architectureImg3.e6f56bf9.jpeg";